import { SxProps } from "@mui/material";

import { theme } from "../../mui-customs/Theme";

export const modal: SxProps = {
  display: "grid",
  placeItems: "center",
};
export const root: SxProps = {};

export const controllerContainer: SxProps = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  mt: 2,
  gap: { xs: 0, md: 2 },
};

export const buttonContainer: SxProps = {
  display: "flex",
  gap: 2,
  mt: 2,
};

export const addImageButtonContainer: SxProps = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  mb: 1,
};

export const addImageIconButton: SxProps = {
  p: 2,
};
export const addImageIcon: SxProps = {
  color: theme.grey1[300],
  fontSize: "30px",
};
